export const AcompanharReguaCobrancaModais = {
  visualizarCobranca: 'visualizarCobranca',
  detalhesCobranca: 'detalhesCobranca',
};
